import { Grid } from "@mui/material";
import React from "react";
import Owners from "./Owners";
import PropertyImgs from "./PropertyImgs";

const Home = ({ unit }) => {
  return (
    <Grid container spacing={3}>
      {unit && unit.unitImgs.length > 0 && (
        <Grid item xs={12} md={6}>
          <PropertyImgs data={unit.unitImgs.map((j) => j.imgUrl)} />
        </Grid>
      )}
      <Grid item xs={12} md={6}>
        <Owners {...{ unit }} />
      </Grid>
    </Grid>
  );
};

export default Home;
